import { useMemo } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../store";
import { RolesDto } from "../dto/roles";
import { OperatorDto } from "../dto/postLogin";

export type OperatorPermissions = {
  canAssign: boolean;
  canTransfer: boolean;
  canClose: boolean;
  canViewAll: boolean;
};

export const useOperatorPermissions = (): OperatorPermissions => {
  const operator = useSelector(
    (s: AppState) => s.operator
  ) as OperatorDto | null;
  const roles = useSelector((s: AppState) => s.roles) as RolesDto[];

  return useMemo<OperatorPermissions>(() => {
    const base: OperatorPermissions = {
      canAssign: false,
      canTransfer: false,
      canClose: false,
      canViewAll: false,
    };

    if (!operator) return base;

    const role = roles.find((r) => r.name === operator.roleName);

    if (!role) return base;

    return {
      canAssign: role.canAssign,
      canTransfer: role.canTransfer,
      canClose: role.canClose,
      canViewAll: role.canViewAll,
    };
  }, [operator, roles]);
};
